import { Editor } from "@tiptap/core"
import StarterKit from "@tiptap/starter-kit"
import Blockquote from "@tiptap/extension-blockquote"
import Placeholder from "@tiptap/extension-placeholder"
import Link from "@tiptap/extension-link"
import { createMentionExtension } from "./mention"
import { createSlashCommandsExtension } from "./slash_commands"
import { createImageExtension, uploadImage } from "./image_upload"

// Blockquote without the `> ` markdown input rule (prevents `10 > 4` from being
// interpreted as a blockquote when `>` appears at the start of a line)
const BlockquoteNoInputRule = Blockquote.extend({
  addInputRules() {
    return []
  },
})

export function createEditor({
  element,
  content,
  placeholder,
  mentionsUrl,
  onUpdate,
}) {
  const extensions = [
    StarterKit.configure({
      blockquote: false, // disable StarterKit's bundled blockquote
    }),
    BlockquoteNoInputRule, // use ours (no markdown shortcut, but still fully functional)
    Placeholder.configure({ placeholder: placeholder || "Write something..." }),
    Link.configure({ openOnClick: false }),
    createImageExtension(),
    createSlashCommandsExtension(),
  ]

  if (mentionsUrl) {
    extensions.push(createMentionExtension(mentionsUrl))
  }

  const editor = new Editor({
    element,
    extensions,
    content: content || undefined,
    onUpdate: ({ editor }) => {
      onUpdate?.(editor.getJSON())
    },
  })

  // Listen for image upload events from slash command
  element.addEventListener("tiptap:upload-image", (event) => {
    const { file } = event.detail
    uploadImage(file).then((url) => {
      editor.chain().focus().setImage({ src: url, alt: file.name }).run()
    })
  })

  return editor
}
